<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario tarefa-modal" (click)="$event.stopPropagation()">
    <div class="ribbon-wrapper" *ngIf="isTaskOverdue()"><div class="ribbon">ATRASADA</div></div>

    <header class="tarefa-header" [class.com-recuo]="isTaskOverdue()">
      <div class="titulo-container">
        <h5>{{ tarefa.descricao }}</h5><span class="tarefa-id">#{{ tarefa.id }}</span>
        <span class="status-badge" [ngClass]="{'status-neutro': tarefa.status === 0 || tarefa.status === 5, 'status-afazer': tarefa.status === 1, 'status-andamento': tarefa.status === 2, 'status-validacao': tarefa.status === 3, 'status-fechada': tarefa.status === 4}">{{ getStatusDescription(tarefa.status) }}</span>
      </div>
      <button type="button" class="fechar-modal" (click)="fecharModal()" aria-label="Fechar"><i class="fa fa-close"></i></button>
    </header>

    <div class="tarefa-conteudo">
      <main>
        <section class="painel descricao-painel">
          <h6>Descrição</h6>
          <p>{{ tarefa.descricaoDetalhada || tarefa.descricao }}</p>
        </section>
        <section class="datas-tarefa">
          <div><i class="fa fa-calendar"></i><span>Início</span><strong>{{ tarefa.dataInicial | date:'dd/MM/yyyy HH:mm' }}</strong></div>
          <div *ngIf="tarefa.status != 4"><i class="fa fa-clock-o"></i><span>Previsão de término</span><strong>{{ tarefa.dataPrevisaoFinalizacao | date:'dd/MM/yyyy HH:mm' }}</strong></div>
          <div *ngIf="tarefa.status == 4"><i class="fa fa-check-circle"></i><span>Finalizada em</span><strong>{{ tarefa.dataFinalizacao | date:'dd/MM/yyyy HH:mm' }}</strong></div>
        </section>
      </main>

      <aside class="tarefa-acoes">
        <div class="responsavel-card">
          <div class="fundo-iniciais">{{ buscarIniciais(tarefa.responsavel) }}</div>
          <div><small>Responsável</small><strong>{{ tarefa.responsavel }}</strong></div>
        </div>
        <ng-container *ngIf="!tarefa.finalizada">
          <select [(ngModel)]="usuarioSelecionado" class="form-control">
            <option value="0">Selecione o usuário</option>
            <option *ngFor="let usuario of usuarios.itens" [value]="usuario.id">{{ usuario.nome }}</option>
          </select>
          <button type="button" class="btn btn-outline-primary btn-funcao" (click)="alterarResponsavel()"><i class="fa fa-user"></i> Alterar responsável</button>
          <button type="button" class="btn btn-primary btn-funcao" (click)="iniciarTarefa()" *ngIf="tarefa.status == 1"><i class="fa fa-play-circle-o"></i> Iniciar tarefa</button>
          <button type="button" class="btn btn-warning btn-funcao" (click)="enviarValidacao()" *ngIf="tarefa.status == 2"><i class="fa fa-check-circle-o"></i> Enviar para validação</button>
          <button type="button" class="btn btn-success btn-funcao" (click)="finalizarTarefa()" *ngIf="tarefa.status == 3"><i class="fa fa-check"></i> Finalizar tarefa</button>
        </ng-container>
      </aside>
    </div>

    <section class="atividade-tarefa">
      <div>
        <h6><i class="fa fa-comments-o"></i> Comentários</h6>
        <div class="lista-atividade" *ngIf="tarefa.comentariosDetalhes?.length; else semComentarios">
          <article class="atividade-item" *ngFor="let item of tarefa.comentariosDetalhes">
            <div class="atividade-meta"><strong>{{ item.usuario }}</strong><span>{{ item.dataRealizado | date:'dd/MM/yyyy HH:mm' }}</span></div><p>{{ item.texto }}</p>
          </article>
        </div>
        <ng-template #semComentarios><p class="estado-vazio">Nenhum comentário cadastrado.</p></ng-template>
      </div>
      <div>
        <h6><i class="fa fa-history"></i> Histórico</h6>
        <div class="lista-atividade" *ngIf="tarefa.movimentacoesDetalhes?.length; else semHistorico">
          <article class="atividade-item" *ngFor="let item of tarefa.movimentacoesDetalhes">
            <div class="atividade-meta"><strong>{{ item.usuario }}</strong><span>{{ item.dataRealizado | date:'dd/MM/yyyy HH:mm' }}</span></div><p>{{ item.descricao }}</p>
          </article>
        </div>
        <ng-template #semHistorico><p class="estado-vazio">Nenhuma movimentação registrada.</p></ng-template>
      </div>
    </section>

    <section class="novo-comentario" *ngIf="!tarefa.finalizada">
      <label for="comentarioTarefa"><i class="fa fa-comment-o"></i> Adicionar comentário</label>
      <div class="comentario-form">
        <textarea id="comentarioTarefa" [(ngModel)]="comentario" class="form-control" rows="3" placeholder="Escreva um comentário..."></textarea>
        <button type="button" class="btn btn-primary" (click)="enviarComentario()" [disabled]="!comentario.trim()"><i class="fa fa-send"></i> Enviar comentário</button>
      </div>
    </section>
  </div>
</div>
